/**
  * http://toxcct.free.fr/polars/generator.htm
 */
import moment from 'moment';
//import GPX from "ol/format/GPX.js";
import * as c from "./common.js";
import * as mapplayer from "./ui-map/map.js";
import * as polar from "./ui-components/polar-plotly.js";
import * as polarbuilder from "./ui-components/polar-builder.js";
import * as help from "./ui-components/help-loader.js";
import { Info } from "./domain/Info.js";
import * as gd from './utils/drive-helpers.js';
import { MainBoatList } from './ui-components/MainBoatList.js';
import { MainSettingsPage } from './ui-components/MainSettingsPage.js';
import { CourseCreator } from './ui-components/CourseCreator.js';
import { TrackEditor } from './ui-components/TrackEditor.js';
import * as util from './utils/utils.js';
import {notifyError} from "./utils/utils.js";
import { WeatherDataWidgetsDeck } from './ui-components/WeatherDataWidgetsDeck.js';
import { StationSeries } from './weather/StationSeries.js';
import annotationEditIconUrl from '../icons/edit.svg?url';

const LOCAL_STORAGE = {
  SHIPNAME:"defaultShipName"
}

let mainBoatList = null;
let mainSettingsPage = null;
let courseCreator = null;
let trackEditor = null;
let weatherDataWidgets = null;
let _postAnimateReady = false;
let _postAnimatePending = false;
let _postAnimateLastTs = 0;

window.onload = async () => {
  try {
    c.hideLoadingSpinner();
    
    const urlParams = new URLSearchParams(window.location.search);
    const fileId = urlParams.get('id');
    const settingsFileId = urlParams.get('sid');
    const infoFileId = urlParams.get('iid');

    if (fileId != undefined) {
      c.dataStore.setSharedFileParams({id: fileId, sid: settingsFileId, iid: infoFileId});
    } else {
      // Check for popup blocker
      const testPopup = window.open("", "_blank", "width=1,height=1");
      if (!testPopup || testPopup.closed || typeof testPopup.closed === 'undefined') {
        alert("Please go to settings and allow popups for this site for google drive login.");
      } else {
        testPopup.close();
      }
    }

    const fileName = urlParams.get('file');

    const postLoadFn = async () => {
      if (!c.dataStore.isSharedFileMode()) {
        try {
          await c.dataStore.loadSettingsAsync();
        } catch (e) {
          notifyError(`Could not load setings file `,e); 
        }
        try {
          c.dataStore.ensurePolarLoadedAsync();
        } catch (e) {
          notifyError(`Error loading polar file `,e); 
        }  
        playerModeButtonSettings.disabled = false;
        playerModeButtonPolar.disabled = false;
      }
      mainSettingsPage = new MainSettingsPage(c.dataStore, gd, c, c.dataStore.getSettings());
      mainSettingsPage.init();

      if (fileName) {
        loadFileByName(fileName);
      }
    };
    gd.initGoogleDriveAsync(postLoadFn);
    document.getElementById("g_id_signin").addEventListener("click", () => {
      gd.initGoogleDriveAsync(postLoadFn);
    });

    updateTrackStyle(c._trackStyle);

    if (c.dataStore.isSharedFileMode()) {
      loadSharedFile();
      const controls = document.getElementById('controls-visible');
      controls.style.display = "none";
    }
    
    updateFileControlButtonState(c.dataStore.getRace());
  } catch (e) {
    notifyError(`Error during page load:`,e); 
  }
};



//****************************************** UI Initialization ***************************************************************** */


//****************************************** icon panel ***************************************************************** */
function updateTrackStyle(style) {
  c.setTrackStyle(style);
  mapplayer.setTrackStyle(style);
  createColorLegend(style);
}

const twsCtrl = document.getElementById('ctrlShowWindSpd');
const sogCtrl = document.getElementById("ctrlShowSOG");
const stwCtrl = document.getElementById("ctrlShowSTW");
const currentCtrl = document.getElementById("ctrlShowCurrent");
const vmgCtrl = document.getElementById("ctrlShowVMG");
const polarPerfCtrl = document.getElementById('ctrlShowPolarPerf');


function setActiveTrackStyleButton(activeCtrl) {
  [twsCtrl, sogCtrl, stwCtrl, currentCtrl, vmgCtrl, polarPerfCtrl].forEach(ctrl => ctrl.classList.remove('selected'));
  activeCtrl.classList.add('selected');
}

twsCtrl.addEventListener("click", () => {
  updateTrackStyle(c.TRACK_STYLE.TWS);
  setActiveTrackStyleButton(twsCtrl);
});

sogCtrl.onclick = () => {
  updateTrackStyle(c.TRACK_STYLE.SOG);
  setActiveTrackStyleButton(sogCtrl);
};

stwCtrl.onclick = () => {
  updateTrackStyle(c.TRACK_STYLE.STW);
  setActiveTrackStyleButton(stwCtrl);
};

currentCtrl.onclick = () => {
  updateTrackStyle(c.TRACK_STYLE.CURRENT);
  setActiveTrackStyleButton(currentCtrl);
};

vmgCtrl.onclick = () => {
  updateTrackStyle(c.TRACK_STYLE.VMG);
  setActiveTrackStyleButton(vmgCtrl);
};

polarPerfCtrl.addEventListener('click', async () => {
  const settings = c.dataStore.getSettings();
  if (!settings) {
    alert('Settings not loaded yet');
    return;
  }

  const polarFile = settings.getDefaultPolarFile();
  if (!polarFile) {
    alert('Choose a polar file in settings');
    showPlayerView('settings');
    return;
  }
  
  try {
    await c.dataStore.ensurePolarLoadedAsync();
    
    updateTrackStyle(c.TRACK_STYLE.POLAR_PERF);
    setActiveTrackStyleButton(polarPerfCtrl);
  } catch (error) {
    notifyError(`Error loading polar `, error);
  } 
});

//******************************************* Controls / Boat Listing *********************************************************** */

function createColorLegend(style) {
  const legendContainer = document.getElementById("colorLegend");
  const labelFormatter = (v) => v < 10 ? v.toFixed(1) : v.toFixed(0);
  legendContainer.innerHTML = ""; // Clear previous content
  const t = legendContainer.appendChild(document.createElement("div"));
  t.className = 'color-legend-heading'
  t.innerHTML = style.title;
  const values = style.colorDomain;
  for(let i=0; i < values.length; i++) {
    const val = values[i];
    const row = document.createElement("div");
    row.style.display = "flex";
    row.style.alignItems = "center";
    row.style.marginBottom = "4px";
    
    const swatch = document.createElement("div");
    swatch.style.width = "10px";
    swatch.style.backgroundColor = style.colorMap(val).hex();
    swatch.style.marginRight = "5px";
    swatch.style.border = "1px solid #ccc";
    const label = document.createElement("span");
    swatch.style.height = "15px";
    label.textContent = labelFormatter(val);

    row.appendChild(swatch);
    row.appendChild(label);
    legendContainer.appendChild(row);
  };
}

//***********************************************      DATA LOAD        **************************************************

const saveAsButton = document.getElementById("saveAsButton");
const saveButton = document.getElementById("saveButton");

async function loadSharedFile() {
  c.showLoadingSpinner();
  try {
    await c.dataStore.loadFromSharedFile(c.setLoadingMessage);
    startPlayerWithRace(c.raceData());
  } catch (e) {
    notifyError("Could not load shared file",e);
  } finally {
    c.hideLoadingSpinner();
  }
}

async function loadFileByName(fileName) {
  c.showLoadingSpinner();
  try {
    mapplayer.stopPlaying();
    const folder = await gd.ensureDataFolderAsync();
    const result = await gd.downloadNamedFileFromDataFolderAsync(folder, fileName);
    if (result) {
      const doc = {id: result.id, name: fileName};
      await c.dataStore.loadFromGDrive(doc, c.setLoadingMessage);
      updateFileControlButtonState(c.raceData());
      startPlayerWithRace(c.raceData());
      document.getElementById("fileNameSelected").textContent = fileName;
    } else {
      alert(`File not found: ${fileName}`);
    }
  } catch (error) {
    notifyError(`Error loading file`,error);
  } finally {
    c.hideLoadingSpinner();
  }
}

function updateFileControlButtonState(raceData) {
  const shareButton = document.getElementById("shareButton");
  const setAvailable = (el, available) => el.classList.toggle('btn-available', available);

  if (raceData == null || raceData.sail() == null) {
    setAvailable(shareButton, false);
    setAvailable(saveAsButton, false);
    setAvailable(saveButton, false);
    setAvailable(annotateButton, false);
    return;
  }

  setAvailable(saveAsButton, !!raceData.sail().fileName);

  const hasDriveFile = raceData.sail().hasFileId();
  setAvailable(saveButton, hasDriveFile);
  setAvailable(annotateButton, hasDriveFile);
  setAvailable(shareButton, hasDriveFile && !c.dataStore.isSharedFileMode());
}

function showShareDialog(link) {
  const shareLinkInput = document.getElementById("shareLinkInput");
  const shareDialog = document.getElementById("shareDialog");
  const shareFeedback = document.getElementById("shareFeedback");
  shareLinkInput.value = link;
  shareFeedback.textContent = "";
  shareFeedback.style.display = "none";
  shareDialog.style.display = "block";
  shareLinkInput.select();
  shareLinkInput.focus();
}

function hideShareDialog() {
  const shareLinkInput = document.getElementById("shareLinkInput");
  const shareDialog = document.getElementById("shareDialog");
  const shareFeedback = document.getElementById("shareFeedback");
  shareDialog.style.display = "none";
  shareLinkInput.value = "";
  shareFeedback.textContent = "";
  shareFeedback.style.display = "none";
}

async function copyLinkToClipboard() {
  const shareLinkInput = document.getElementById("shareLinkInput");
  const shareFeedback = document.getElementById("shareFeedback");
  const link = shareLinkInput.value;
  
  if (!navigator.clipboard || !navigator.clipboard.writeText) {
    shareFeedback.textContent = "Could not copy to clipboard. Please copy the link manually.";
    shareFeedback.style.display = "block";
    return;
  }
  
  try {
    await navigator.clipboard.writeText(link);
    shareFeedback.textContent = "Link copied!";
    shareFeedback.style.display = "block";
  } catch (error) {
    console.error("Failed to copy to clipboard:", error);
    shareFeedback.textContent = "Could not copy to clipboard. Please copy the link manually.";
    shareFeedback.style.display = "block";
  }
}

document.getElementById("copyLinkButton").addEventListener("click", () => {
  copyLinkToClipboard();
});

document.getElementById("closeShareDialogButton").addEventListener("click", () => {
  hideShareDialog();
});

document.querySelector("#shareDialog .modal-backdrop").addEventListener("click", () => {
  hideShareDialog();
});

const shareButton = document.getElementById("shareButton");
shareButton.addEventListener("click", async () => {
  shareButton.disabled = true;
  const originalHTML = shareButton.innerHTML;
  shareButton.innerHTML = '<img src="icons/spinner.webp" alt="Sharing..." style="height: 12px; vertical-align: middle;">';
  
  try {
    const result = await c.dataStore.shareCurrentRace(c.setLoadingMessage);
    
    if (result.success) {
      showShareDialog(result.link);
    } else {
      alert(result.error);
      console.error('Share operation failed:', result.error, 'Type:', result.errorType);
    }
  } catch (error) {
    notifyError(`Unexpected error during share`,error);
  } finally {
    shareButton.innerHTML = originalHTML;
    shareButton.disabled = false;
  }
});

// function resetSaveButtons() {
//   const shareButton = document.getElementById("shareButton");
//   //saveButton.classList.add('icon-button-disabled');
//   //saveAsButton.classList.add('icon-button-disabled');
//   saveAsButton.style.display = 'none';
//   shareButton.style.display = "none";
// }

// resetSaveButtons();

document.getElementById("loadJsonFileButton")
.addEventListener("click", async () => {
  loadFilesFromGDriveAsync();
});

const fileInput = document.getElementById("fileInputNMEA");
document.getElementById("importFileButton")
  .addEventListener("click", async () => {
    fileInput.click()
  });

fileInput.addEventListener("change", async (e) => {
  const file = e.target.files[0];
  if (file == undefined || file == null) return;
  let fileName = file.name;
  if (!fileName.endsWith('.gz')) {
    fileName = fileName+".gz";
  }
  const reader = new FileReader();
  //resetSaveButtons();
  updateFileControlButtonState(null);
  c.dataStore.reset();
  mapplayer.stopPlaying();
  if (file.name.toLowerCase().endsWith(".txt")) {
    c.showLoadingSpinner();
    reader.onload = async function (evt) {
      await startPlayerWithNmeaText(evt.target.result, fileName);
      saveNMEAFileGDriveAsync(evt.target.result,fileName);
      c.hideLoadingSpinner();

    };
    reader.readAsText(file);
  // } else if (file.name.toLowerCase().endsWith(".gpx")) {
  //   populateFeaturesFromGpxFiles([file]);
  // } else if (file.name.toLowerCase().endsWith(".json")) {
  //   c.showLoadingSpinner();
  //   reader.onload = function (evt) {
  //     populateFeaturesFromJSONText(evt.target.result, file.name, null);
  //     c.hideLoadingSpinner();
  //   };
  //   reader.readAsText(file);
  } else {
    console.log("error", e.target);
  }
  document.getElementById("fileNameSelected").textContent = fileName;
});

async function saveNMEAFileGDriveAsync(text, name) {
  c.saveButtonSpinnerOn(saveButton);
  c.saveButtonSpinnerOn(saveAsButton);
  try {
    await c.dataStore.saveNMEAToGDrive(text, name, c.setLoadingMessage);
  } catch (error) {
    notifyError(`An error occurred while saving the file`,error);
  } finally {
    c.saveButtonSpinnerOff(saveButton);
    c.saveButtonSpinnerOff(saveAsButton);
  }
}

async function startPlayerWithNmeaText(text, fileName) {
  await c.dataStore.loadFromNMEA(text, fileName, c.setLoadingMessage);
  console.log("Parsed, sanitized NMEA data:",c.dataStore.raceData.sail().data);
  updateFileControlButtonState(c.raceData());
  startPlayerWithRace(c.raceData());
}

function startPlayerWithRace(race) {
  _postAnimateReady = false;
  if (race.sail().getTracks().length == 0) {
    return;
  }
  const settings = c.dataStore.getSettings();
  const vesselTrack = race.sail().getVesselTrack();
  
  if (vesselTrack.getShipName() == null || vesselTrack.getShipName() == "") {
    vesselTrack.setShipName(localStorage.getItem(LOCAL_STORAGE.SHIPNAME))
  }
  createAnnotationsDisplay();
  
  const map = mapplayer.getMap();
  initCourseCreator(race, map);
  initTrackEditor(race, map);
  initWeatherDataWidgets(race, map);
  
  mainBoatList = new MainBoatList(c.dataStore, mapplayer, settings);
  mainBoatList.init();
  
  mapplayer.initMap(postAnimateHook, race, settings);

  const course = race.info().getCourse();
  if (course) {
    race.buildRaceTracks();
    const raceTracks = race.getRaceTracks();
    mainBoatList.setRaceTracksN(raceTracks);
    console.log(race.info().prettyPrintCourse());
    //TODO at this point setCurrentPlayTime is called but it could be returned and set out hear, more clear
    courseCreator.loadCourse();
    courseCreator.displayCourse();
  } else {
    courseCreator.clearCourse();
  }

  mainBoatList.createLegend();
  _postAnimateReady = true;
}

function initCourseCreator(race, map) {
  if (courseCreator) {
    courseCreator.destroy();
  }
  courseCreator = new CourseCreator(map, race.info(), (info) => {
    console.log(util.stringifyWithMaxDepth(info.getCourse()));
    c.raceData().buildRaceTracks();
    const raceTracks = c.raceData().getRaceTracks();
    mainBoatList.setRaceTracksN(raceTracks);
    saveRaceInfoDataFileGDriveAsync();
  });
  console.log(util.stringifyWithMaxDepth(race.info().getCourse()));
  courseCreator.setTrackAnimator({
    getCurrentTime: () => mapplayer.getCurrentPlayTime(),
    setCurrentPlayTime: (ts) => mapplayer.setCurrentPlayTime(ts)
  });
  return map;
}

function initTrackEditor(race, map) {
  if (trackEditor) {
    trackEditor.deactivate();
  }
  const onActivate = () => {
    race.sail().pruneAIS();
    mapplayer.initAnimator();
    mapplayer.disablePlayer(true);
  };

  const onTracksModified = () => {
    race.buildRaceTracks();
    const raceTracks = race.getRaceTracks();
    mainBoatList.setRaceTracksN(raceTracks);
    mapplayer.initAnimator();
  };

  const onSave = async () => {
    await saveDataFileGDriveAsync();
  };

  const onDeactivate = () => {
    race.sail().interpolateAIS();
    race.buildRaceTracks();
    const raceTracks = race.getRaceTracks();
    mainBoatList.setRaceTracksN(raceTracks);
    mapplayer.initAnimator();
    mapplayer.disablePlayer(false);
  };

  trackEditor = new TrackEditor(map, race.sail(), onTracksModified, onSave, onActivate, onDeactivate);
}

function initWeatherDataWidgets(race, map) {
  weatherDataWidgets?.destroy();
  weatherDataWidgets = new WeatherDataWidgetsDeck(map, race.extent(), async (stations) => {
    race.info().storeWeatherStations(stations);
    await saveRaceInfoDataFileGDriveAsync();
  });
  weatherDataWidgets.setVisible(ctrlToggleWeather.classList.contains('selected'));
  weatherDataRefreshButton.classList.add('btn-available');
  const weatherStations = race.info().loadWeatherStations();
  if (weatherStations?.length) {
    weatherDataWidgets.loadStations(weatherStations);
  } else {
    weatherDataWidgets.fetchWeather(race.extent(), true);
  }
}

document.getElementById('fileControlsExpand').addEventListener('click', () => {
  document.querySelector('.general-file-controls').classList.toggle('expanded');
});

const weatherDataRefreshButton = document.getElementById('weatherDataRefreshButton');
weatherDataRefreshButton.addEventListener('click', () => {
  weatherDataWidgets.fetchWeather(c.raceData().extent());
});

const ctrlToggleWeather = document.getElementById('ctrlToggleWeather');
ctrlToggleWeather.addEventListener('click', () => {
  const enabled = ctrlToggleWeather.classList.toggle('selected');
  weatherDataWidgets?.setVisible(enabled);
});

document.querySelector('.action-buttons').addEventListener('click', (e) => {
  if (e.target.closest('#fileControlsExpand')) return;
  if (!e.target.closest('button')) return;
  document.querySelector('.general-file-controls').classList.remove('expanded');
});

document.getElementById('startPoint').addEventListener('click', (e) => {
  if (!courseCreator) return;
  if (courseCreator.isActive()) {
    courseCreator.deactivate();
    mapplayer.setCourseEditingActive(false);
  } else {
    courseCreator.activate();
    mapplayer.setCourseEditingActive(true);
  }
});

document.getElementById('trackEditorSaveButton').addEventListener('click', () => trackEditor?._showSaveDialog());
document.getElementById('trackEditorCutStart').addEventListener('click', () => trackEditor?._confirmCutStart());
document.getElementById('trackEditorCutEnd').addEventListener('click', () => trackEditor?._confirmCutEnd());
document.getElementById('trackEditorCloseButton').addEventListener('click', () => trackEditor?._confirmClose());

document.getElementById('trackEditorButton').addEventListener('click', (e) => {
  if (trackEditor.isActive()) {
    if (trackEditor.hasUnsavedChanges()) {
      const dialog = document.createElement('div');
      dialog.className = 'modal-dialog';
      dialog.style.display = 'flex';

      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop';
      dialog.appendChild(backdrop);

      const content = document.createElement('div');
      content.className = 'modal-content';
      const changeCount = trackEditor._changeLog ? trackEditor._changeLog.length : 0;
      content.innerHTML = `
        <h3>Close Without Saving?</h3>
        <p>You have ${changeCount} unsaved change${changeCount > 1 ? 's' : ''}. Close without saving?</p>
        <div class="modal-buttons">
          <button id="closeEditorOK" class="primary-button">Close</button>
          <button id="closeEditorCancel" class="secondary-button">Cancel</button>
        </div>
      `;
      dialog.appendChild(content);

      document.body.appendChild(dialog);

      document.getElementById('closeEditorOK').addEventListener('click', () => {
        dialog.remove();
        trackEditor.deactivate();
      });

      const cancelHandler = () => {
        dialog.remove();
      };

      document.getElementById('closeEditorCancel').addEventListener('click', cancelHandler);
      backdrop.addEventListener('click', cancelHandler);
    } else {
      trackEditor.deactivate();
    }
  } else {
    trackEditor.activate();
  }
});


// function not used, keep for later
// function populateFeaturesFromGpxFiles(files) {
//   const allFeatures = [];
//   files.forEach((file) => {
//     const format = new GPX();
//     const features = format.readFeatures(file.content, {
//       featureProjection: map.getView().getProjection(),
//     });
//     console.log("File ", file.name, " loaded");
//     allFeatures.push(...features);
//   });
//   return allFeatures;
// }

function clickHandler(ts) { 
  mapplayer.setCurrentPlayTime(ts); 
};

function postAnimateHookImpl() {
  updateAnnotationsDisplay();
  mainBoatList.updateLegendAll();
  polar.updatePolarPane(clickHandler, c.raceData().sail().data.vessel);
  weatherDataWidgets?.onTimeUpdate(mapplayer.getCurrentPlayTime().valueOf());
}

function postAnimateHook() {
  if (!_postAnimateReady)
    return;

  const ts = Date.now();
  if (_postAnimateLastTs + 250 < ts){
    _postAnimateLastTs = ts;
    postAnimateHookImpl();
    
  } else {
    if (_postAnimatePending) 
      return;
    _postAnimatePending = true;
    setTimeout(() => { 
      _postAnimatePending = false;
      postAnimateHookImpl();
    }, 500);
  }
}

//Is there a bug here, where does raceData get set?
async function loadFilesFromGDriveAsync() {
  try {
    c.showLoadingSpinner();
    // resetSaveButtons();
    updateFileControlButtonState(null);
    mapplayer.stopPlaying();
    await c.dataStore.pickAndLoadFromGDrive((doc) => {
      updateFileControlButtonState(c.raceData());
      startPlayerWithRace(c.raceData());
      document.getElementById("fileNameSelected").textContent = doc.name;
      c.hideLoadingSpinner();
    }, (response) => {
      updateFileControlButtonState(c.raceData());
      console.log(response);
      c.hideLoadingSpinner();
    }, c.setLoadingMessage);
  } catch (e) {
    notifyError(`Failure loading race `,e);
  }
}

//TODO this code doesn't seem to actually trigger a delayed save. The setInterval is not called.
let _saveNeededTimestamp = null;
function flagSaveNeeded() {
  _saveNeededTimestamp = moment();
}
function clearSaveFlag() {
  _saveNeededTimestamp = null;
}
setInterval(()=> {
  if (_saveNeededTimestamp != null && moment().diff(_saveNeededTimestamp) > 5000) {
    saveRaceInfoDataFileGDriveAsync();
  }
}, 5000);

document.getElementById("saveAsButton").onclick = async () => {
  try {
    let sampleName = c.raceData().sail().fileName.replace(/\..+$/,"");
    let fileName = prompt(
      "Enter the file name to save:",
      sampleName+'.json'
    );
    if (!fileName) {
      alert("File name is required to save the file.");
      return;
    }
    if (!fileName.endsWith('.json')) {
      fileName = fileName+".json.gz";
    }
    if (!fileName.endsWith('.gz')) {
      fileName = fileName+".gz";
    }

    c.saveButtonSpinnerOn(saveButton);
    c.saveButtonSpinnerOn(saveAsButton);
    try {
      // c.raceData().sail().setData(data);
      const id = await c.dataStore.saveAsToGDrive(fileName, c.setLoadingMessage);
      //re-load to trigger calculated fields
      await c.dataStore.loadFromGDrive({id:id, name:fileName}, c.setLoadingMessage);
      mainBoatList.createLegend();
      updateFileControlButtonState(c.raceData());
      document.getElementById("fileNameSelected").textContent = fileName;
      startPlayerWithRace(c.raceData());
    } catch (error) {
      notifyError(`Error saving file `, error);
    } finally {
      c.saveButtonSpinnerOff(saveButton);
      c.saveButtonSpinnerOff(saveAsButton);
    }
  } catch (e) {
    notifyError("Failure saving ",e);
  }
};

saveButton.onclick = async () => {
  saveDataFileGDriveAsync();
};

async function saveDataFileGDriveAsync() {
  try {
    if (!c.raceData().sail().hasFileId()) {
      alert("Can't save file, no id on Google Drive");
      return;
    }
    c.saveButtonSpinnerOn(saveButton);
    c.saveButtonSpinnerOn(saveAsButton);
    await c.dataStore.saveToGDrive(c.setLoadingMessage);
    mainBoatList.createLegend();
  } catch (error) {
    notifyError(`Error saving file `,error);
  } finally {
    c.saveButtonSpinnerOff(saveButton);
    c.saveButtonSpinnerOff(saveAsButton);
  }
}

let _savingRaceInfo = false;
async function saveRaceInfoDataFileGDriveAsync() {
  try {
    if (_savingRaceInfo) return;
    _savingRaceInfo = true;
    c.saveButtonSpinnerOn(saveButton);
    c.saveButtonSpinnerOn(saveAsButton);
    await c.dataStore.saveRaceInfoToGDrive(c.setLoadingMessage);
    clearSaveFlag();
  } catch (error) {
    notifyError(`Error saving file `,error);
  } finally {
    _savingRaceInfo = false;
    c.saveButtonSpinnerOff(saveButton);
    c.saveButtonSpinnerOff(saveAsButton);
  }
}



/*********************************************    Annotations    ********************************************** */
const annotateButton = document.getElementById("annotateButton");
const raceNotes = document.getElementById('race-notes');
raceNotes.addEventListener("change",(e) => {
  c.raceData().info().info.raceNotes = e.target.value;
  flagSaveNeeded();
});

annotateButton.addEventListener("click", () => {
  _showAllAnnotations = _showAllAnnotations ? false : true;
  annotateButton.classList.toggle('selected', _showAllAnnotations);
  showAnnotationEditPanel(_showAllAnnotations);
  updateAnnotationsDisplay();
  clearAnnotationEditButtonSelect();
  mapplayer.clearTimeWindow();
  const raceNotesWrapper = document.getElementById('annotation-notes-wrapper');
  raceNotesWrapper.style.display = raceNotesWrapper.style.display == 'block' ? 'none' : 'block';
});

document.getElementById("annotationCloseButton").addEventListener("click", () => {
  showAnnotationEditPanel(false);
  clearAnnotationEditButtonSelect();
});
document.getElementById("beginButton").addEventListener("click", () => {
  setAnnotateBeginValue(mapplayer.getCurrentPlayTime());
});

document.getElementById("endButton").addEventListener("click", () => {
  setAnnotateEndValue(mapplayer.getCurrentPlayTime());
});

document.getElementById("annotationDeleteButton").onclick = () => {
  const id = document.getElementById('annotationEditedId');
  if (id.value == null || id.value == "" ) {
    clearAnnotationPanelContent();
  } else {
    const foundIdx = c.raceData().info().getAnnotations().findIndex((x) => parseInt(id.value) == x.id);
    if (foundIdx >= 0) {
      c.raceData().info().spliceAnnotations(foundIdx, 1);
    }
    createAnnotationsDisplay();
    showAnnotationEditPanel(_showAllAnnotations);
    flagSaveNeeded();
    c.raceData().info().orderRaceInfoAnnotations();
    updateAnnotationsDisplay();
    clearAnnotationEditButtonSelect();
  }
}

let _annotationEditing = null;
document.getElementById("annotationSaveButton").onclick = async () => {
  try {
    const begin = moment(document.getElementById('beginTimeInput').value);
    const end = moment(document.getElementById('endTimeInput').value);
    if (!begin.isValid() || !end.isValid())  {
      alert("Begin or end is invalid.");
      return;
    }
    const labels = [];
    const l1 = document.getElementById('label1').value;
    if (l1 != null && l1.trim().length > 0) labels.push(l1);
    const l2 = document.getElementById('label2').value;
    if (l2 != null && l2.trim().length > 0) labels.push(l2);
    
    const notes = document.getElementById('notes').value;
    if (labels.length == 0 && (notes != null && notes.trim().length == 0)) {
      alert("Please provide a label or note.");
      return;
    }
    let a=null;
    if (c.raceData().info().getAnnotations() == null) {
      c.raceData().info().info.annotations = [];
    }
    if (_annotationEditing != null) {
      a=_annotationEditing;
      a.begin_ts = begin;
      a.end_ts = end;
      a.labels = labels;
      a.notes = notes;
      _annotationEditing = null;
    } else {
      a = Info.newAnnotation(moment().unix(), begin, end, notes, labels);
      c.raceData().info().pushAnnotation(a);
    }
    createAnnotationsDisplay();

    flagSaveNeeded();
    c.raceData().info().orderRaceInfoAnnotations();
    clearAnnotationPanelContent();
    updateAnnotationsDisplay();
    clearAnnotationEditButtonSelect();
  } catch (error) {
    notifyError(`Error saving file `, error);
  } 
};

function setAnnotateEndValue(t) {
  const begin = moment(document.getElementById("beginTimeInput").value);
  if (!begin.isValid() || begin.isBefore(t)) {
    document.getElementById("endTime").textContent = t.format("DD-MM HH:mm:ss");
    document.getElementById("endTimeInput").value = t.toISOString();
    mapplayer.updateTimeWindow(begin, t);
  } else {
    alert("End is before beginning!")
  }
}

function setAnnotateBeginValue(t) {
  const end = moment(document.getElementById("endTimeInput").value);
  if (!end.isValid() || end.isAfter(t)) {
    document.getElementById("beginTime").textContent = t.format("DD-MM HH:mm:ss");
    document.getElementById("beginTimeInput").value = t.toISOString();
    mapplayer.updateTimeWindow(t, end);
  } else {
    alert("End is before beginning!");
  }
}

// controls all the UI state logic about the opening and closing the annotation edit panel
let _weHidPolar = false;
function showAnnotationEditPanel(flag) {
  polar.setButtonEnabled(!flag);
  if (flag && polar.getVisible()) {
    polar.setVisible(false);
    _weHidPolar = true;
  } else if (!flag && _weHidPolar) {
    polar.setVisible(true);
    _weHidPolar = false;
  }
  const annotationsPanel = document.getElementById("annotations");
  annotationsPanel.style.display = flag ? "block" : "none";
  clearAnnotationPanelContent();
  document.getElementById("annotationCloseButton").style.display = _showAllAnnotations ? "none" : "block";
  document.getElementById('annotation-add-control').style.display= flag ? "flex" : "none";
  mapplayer.displayTimeWindow(flag);
}



function clearAnnotationPanelContent() {
  document.getElementById('beginTime').textContent = "   ...   ";
  document.getElementById('beginTimeInput').value = "";
  document.getElementById('endTime').textContent = "   ...   ";
  document.getElementById('endTimeInput').value = "";
  document.getElementById('label1').value = "";
  document.getElementById('label2').value = "";
  document.getElementById('notes').value = "";
  document.getElementById('annotationEditedId').value = "";
  mapplayer.clearTimeWindow();
}

function openAnnotationEditPanel(id) {
  showAnnotationEditPanel(true);
  const annotationsPanel = document.getElementById("annotations");
  annotationsPanel.style.display = "block";
  const foundIdx = c.raceData().info().getAnnotations().findIndex((x) => parseInt(x.id) == id);
  if (foundIdx >= 0) {
    const a = c.raceData().info().getAnnotations()[foundIdx];
    _annotationEditing = a;
    setAnnotateBeginValue(moment(a.begin_ts));
    setAnnotateEndValue(moment(a.end_ts));
    if (a.labels.length > 0)
      document.getElementById('label1').value = a.labels[0];
      if (a.labels.length > 1)  
        document.getElementById('label2').value = a.labels[1];
    document.getElementById('notes').value = a.notes;
    document.getElementById('annotationEditedId').value = a.id;
  }
}



let _showAllAnnotations = false;
function updateAnnotationsDisplay() {
  if (window.innerWidth < 768 || c.dataStore.isSharedFileMode())
    return;
  if (c.raceData().sail().getTracks().length > 0) {
    const playTime = mapplayer.getCurrentPlayTime();
    const annotations = c.raceData().info().getAnnotations();
    if (annotations != null) {
      for (let i = 0; i < annotations.length; i++) {
        const a = annotations[i];
        if (_showAllAnnotations || (a.begin_ts.isBefore(playTime) && a.end_ts.isAfter(playTime))) {
          showAnnotationDisplay(a);
        } else {
          hideAnnotationDisplay(a);
        }
      }
    }
  }
}

function createAnnotationsDisplay() {
  if (window.innerWidth < 768 || c.dataStore.isSharedFileMode())
    return;
  
  raceNotes.value = c.raceData().info().info.raceNotes;
  document.getElementById("annotationsDisplay").innerHTML = '';
  const annDisplayDiv = document.getElementById('annotationsDisplay')
  for (let i = 0; i < c.raceData().info().getAnnotations().length; i++) {
      const d = createAnnotationElementsDisplay(c.raceData().info().getAnnotations()[i]);
      annDisplayDiv.appendChild(d);
  }
}


function hideAnnotationDisplay(a) {
  const ann = document.getElementById(a.id);
  ann.style.display = 'none';
}

function showAnnotationDisplay(a) {
  const ann = document.getElementById(a.id);
  ann.style.display = 'flex';
}

function createAnnotationLabel(labelVal) {
  let l = document.createElement('div');
  l.className = 'annotation-label-display';
  l.innerHTML = labelVal;
  l.style.display = labelVal == "" ? "none":"flex";
  return l;
}

function createAnnotationElementsDisplay(a) {
  const rowGroup = document.createElement('div');
  rowGroup.className = 'annotation-row-display';
  rowGroup.id = a.id;
  if (a.labels != null) {
    a.labels.forEach((labelVal) => {
      rowGroup.appendChild(createAnnotationLabel(labelVal));
    });
  }
  if (a.notes != null) {
    const n = document.createElement('div');
    n.className = 'annotation-note-display';
    n.innerHTML = a.notes;
    n.style.display = a.notes == "" ? "none":"flex";
    rowGroup.appendChild(n);
  }
  const b = document.createElement('button');
  b.className = "icon-button";
  b.id = "labelEditButton";
  b.value = a.id;
  b.innerHTML = "<img class='annotation-button-edit' title='Edit annotation' src='icons/${annotationEditIconUrl}'/>"
  b.addEventListener("click", (e) => {
    clearAnnotationEditButtonSelect();
    openAnnotationEditPanel(a.id);
    b.classList.add('selected');
  });
  rowGroup.appendChild(b);
  return rowGroup;
}

function clearAnnotationEditButtonSelect() {
  const annDis = document.getElementById("annotationsDisplay");
  const editButtons = annDis.querySelectorAll('button#labelEditButton');
  for (const otherB of editButtons) {
    otherB.classList.remove('selected');  
  }
  _annotationEditing = null;
}

document.getElementById("annotationAddButton").addEventListener("click", () => {
  clearAnnotationEditButtonSelect();
  showAnnotationEditPanel(true);
});

const playerModeButtonPlayer = document.getElementById("playerModeButtonPlayer");
const playerModeButtonPolar = document.getElementById("playerModeButtonPolar");
const playerModeButtonSettings = document.getElementById("playerModeButtonSettings");
const playerModeButtonHelp = document.getElementById("playerModeButtonHelp");

playerModeButtonPolar.disabled = true;
playerModeButtonSettings.disabled = true;

playerModeButtonPlayer.addEventListener("click", () => {
  showPlayerView('player');
});

playerModeButtonPolar.addEventListener("click", () => {
  showPlayerView('polar');
});

playerModeButtonSettings.addEventListener("click", () => {
  showPlayerView('settings');
});

playerModeButtonHelp.addEventListener("click", () => {
  showPlayerView('help');
});

function showPlayerView(mode) {
  playerModeButtonPlayer.classList.toggle("selected", mode === 'player');
  playerModeButtonPolar.classList.toggle("selected", mode === 'polar');
  playerModeButtonSettings.classList.toggle("selected", mode === 'settings');
  playerModeButtonHelp.classList.toggle("selected", mode === 'help');
  
  document.getElementById("polar-builder").style.display = "none";
  document.getElementById("map-player").style.display = "none";
  document.getElementById("settings-view").style.display = "none";
  document.getElementById("help-viewer").style.display = "none";
  
  if (mode === 'player') {
    document.getElementById("map-player").style.display = "flex";
    mapplayer.updateSize();
    // Refresh boat list to pick up any settings changes
    if (mainBoatList && c.dataStore.getRace()) {
      mainBoatList.createLegend();
    }
  } else if (mode === 'polar') {
    document.getElementById("polar-builder").style.display = "grid";
    polarbuilder.showAsync();
    util.showToast('Select a race section or a polar file to begin');
  } else if (mode === 'settings') {
    document.getElementById("settings-view").style.display = "block";
    mainSettingsPage.updateDisplay();
  } else if (mode === 'help') {
    document.getElementById("help-viewer").style.display = "block";
    help.showHelp();
  }
}


